import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";
import { useT } from "@/lib/i18n";
import { HOME } from "@/constants/testIds";

const Occasions = () => {
    const { lang } = useLang();
    const t = useT(lang);
    const items = t("occasions.list");

    return (
        <section
            id="occasions"
            data-testid={HOME.occasionsSection}
            className="relative py-24 md:py-32 border-y"
            style={{ background: "var(--bg-primary)", borderColor: "rgba(46,16,37,0.08)" }}
        >
            <div className="mx-auto max-w-[1600px] px-6 md:px-10">
                <div className="flex items-baseline justify-between flex-wrap gap-6 mb-12">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="w-8 h-px" style={{ background: "var(--teal)" }} />
                            <span className="font-body text-[11px] uppercase tracking-[0.32em]" style={{ color: "var(--teal)" }}>
                                {t("occasions.eyebrow")}
                            </span>
                        </div>
                        <h2 className="font-serif text-4xl md:text-6xl tracking-tight" style={{ color: "var(--ink-1)" }}>
                            {t("occasions.title")}
                        </h2>
                    </div>
                </div>

                <ul className="divide-y" style={{ borderColor: "rgba(46,16,37,0.14)" }}>
                    {items.map((it, i) => (
                        <motion.li
                            key={it.key}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.05 }}
                            className="group flex items-center justify-between py-6 md:py-8 cursor-default"
                        >
                            <div className="flex items-center gap-6 md:gap-10">
                                <span className="chapter-num text-4xl md:text-6xl" style={{ color: "var(--ink-1)" }}>{String(i + 1).padStart(2, "0")}</span>
                                <div>
                                    <div className="font-serif text-3xl md:text-5xl tracking-tight leading-none" style={{ color: "var(--ink-1)" }}>
                                        {lang === "es" ? it.es : it.en}
                                    </div>
                                    <div className="font-body text-[11px] uppercase tracking-[0.28em] mt-2" style={{ color: "var(--ink-mute)" }}>
                                        {lang === "es" ? it.en : it.es}
                                    </div>
                                </div>
                            </div>
                            <motion.span
                                whileHover={{ x: 8 }}
                                className="hidden md:inline-flex items-center gap-2 font-body text-xs uppercase tracking-[0.28em]"
                                style={{ color: "var(--pink)" }}
                            >
                                {lang === "es" ? "Reservar" : "Book"} →
                            </motion.span>
                        </motion.li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Occasions;
